import './PageHeader.css';

/**
 * @param {{ eyebrow?: string, title: string, intro?: string, children?: React.ReactNode }} props
 */
export default function PageHeader({ eyebrow, title, intro, children }) {
  return (
    <header className="page-header">
      <div className="container">
        <div className="page-header__inner">
          {eyebrow && <p className="eyebrow">{eyebrow}</p>}
          <h1>{title}</h1>
          {intro && <p className="lead">{intro}</p>}
          {children}
        </div>
      </div>
    </header>
  );
}
